import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home.vue'
import {store} from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
        requiresBasicAuth: true,
    },
  },
  {
    path: '/seafarer',
    name: 'Seafarer',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Seafarer.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/view-seafarer',
    name: 'View-Seafarer',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Seafarer.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresBasicAuth: true,
    },
  },  
  {
    path: '/edit-seafarer',
    name: 'Edit-Seafarer',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Seafarer.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/seafarers',
    name: 'Seafarers',
    component: () => import(/* webpackChunkName: "register" */ '@/components/SeafarerList.vue'),
    props: (route) => ({ propData: route.query, subjectAd:null })  ,
    meta: {
        requiresBasicAuth: true,
    },
  }, 
  {
    path: '/online-cvs',
    name: 'OnlineCVs',
    component: () => import(/* webpackChunkName: "register" */ '@/components/PendingSeafarersList.vue'),
    props: (route) => ({ propData: route.query, subjectAd:null })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/client',
    name: 'Client',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Client.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/view-client',
    name: 'view-client',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Client.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/edit-client',
    name: 'edit-client',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Client.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  },   
  {
    path: '/clients',
    name: 'Clients',
    component: () => import(/* webpackChunkName: "register" */ '@/components/ClientList.vue'),
    props: (route) => ({ propData: route.query, subjectAd:null })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/cba',
    name: 'cba',
    component: () => import(/* webpackChunkName: "register" */ '@/components/CBA.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/view-cba',
    name: 'view-cba',
    component: () => import(/* webpackChunkName: "register" */ '@/components/CBA.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/edit-cba',
    name: 'edit-cba',
    component: () => import(/* webpackChunkName: "register" */ '@/components/CBA.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  
  {
    path: '/cbas',
    name: 'cbas',
    component: () => import(/* webpackChunkName: "register" */ '@/components/CBAList.vue'),
    props: (route) => ({ propData: route.query, subjectAd:null })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/vessel',
    name: 'Vessel',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Vessel.vue'),
    // props: (route) => ({ id: route.query.id, subjectAd:null })  ,
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/vessels',
    name: 'Vessels',
    component: () => import(/* webpackChunkName: "register" */ '@/components/VesselList.vue'),
    props: (route) => ({ propData: route.query, subjectAd:null })  ,
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/view-vessel',
    name: 'view-vessel',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Vessel.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/edit-vessel',
    name: 'edit-vessel',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Vessel.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  },   
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "register" */ '@/components/Login.vue'),
    props: true
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: "register" */ '@/components/logout.vue'),
    props: true
  },
  {
    path: '/forgotpassword',
    name: 'PorgotPassword',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ForgotPassword.vue'),    
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "about" */ '@/components/Profile.vue'),
    meta: {
        requiresBasicAuth: true,
    },
  },
  {
    path: '/user',
    name: 'User',
    component: () => import(/* webpackChunkName: "about" */ '@/components/User.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAdminAuth: true,
    },
  },
  {
    path: '/userResetPassword',
    name: 'userResetPassword',
    component: () => import(/* webpackChunkName: "about" */ '@/components/User.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import(/* webpackChunkName: "about" */ '@/components/UserList.vue'),
    meta: {
        requiresAdminAuth: true,
    },
  },
  {
    path: '/cv1',
    name: 'cv1',
    component: () => import(/* webpackChunkName: "about" */ '@/components/CV1.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id, applicant: route.query.applicant }),
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/cv2',
    name: 'cv2',
    component: () => import(/* webpackChunkName: "about" */ '@/components/CV2.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id }),
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/report-contact',
    name: 'report-contact',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportMobile.vue'),
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/report-email',
    name: 'report-email',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportEmail.vue'),
    meta: {
        requiresAuth: true,
    },
  }, 
  {
    path: '/report-status-list',
    name: 'report-status-list',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportStatusList.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-articles-as-of-today',
    name: 'report-articles-as-of-today',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportArticlesAsOfToday.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-articles',
    name: 'report-articles',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportArticles.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-mlcs',
    name: 'report-mlcs',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportVesselMLC.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-sign-on-list',
    name: 'report-sign-on-list',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportSignOnList.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-sign-off-list',
    name: 'report-sign-off-list',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportSignOffList.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-sign-off-pending',
    name: 'report-sign-off-pending',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportSignOffPending.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-current-onboard',
    name: 'report-current-onboard',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportCurrentOnBoard.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-off-signers',
    name: 'report-off-signers',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportOffSignersList.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-travel',
    name: 'report-travel',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportTravel.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-socialsecurity-contrib-seafarer',
    name: 'report-socialsecurity-contrib-seafarer',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportSocialSecurityPerSeafarer.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-socialsecurity-contrib-vessel',
    name: 'report-socialsecurity-contrib-vessel',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportSocialSecurityPerVessel.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-socialsecurity-contrib-client',
    name: 'report-socialsecurity-contrib-client',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportSocialSecurityPerClient.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/report-expiring-docs',
    name: 'report-expiring-docs',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportExpiringDocs.vue'),
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/report-expiring-docs-period',
    name: 'report-expiring-docs-period',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportExpiringDocsPeriod.vue'),
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/report-expired-docs',
    name: 'report-expired-docs',
    component: () => import(/* webpackChunkName: "about" */ '@/components/ReportExpiredDocs.vue'),
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '@/components/About.vue'),
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/dropdowns',
    name: 'dropdowns',
    component: () => import(/* webpackChunkName: "about" */ '@/components/DropDowns.vue'),
    meta: {
        requiresAuth: true,
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "about" */ '@/components/Settings.vue'),
    meta: {
        requiresAdminAuth: true,
    },
  },  
  {
    path: '/view-online-cv',
    name: 'view-online-cv',
    component: () => import(/* webpackChunkName: "about" */ '@/components/PublicSeafarerForm.vue'),
    props: (route) => ({ mode: route.query.mode, id: route.query.id })  ,
    meta: {
        requiresAuth: true,
    },
  },  
  {
    path: '/online-cv-seafarer',
    name: 'online-cv-seafarer',
    component: () => import(/* webpackChunkName: "about" */ '@/components/PublicSeafarerForm.vue'),
    
  },  
  {
    path: '/unauthorized',
    name: 'AccessUnauthorized',
    component: () => import(/* webpackChunkName: "about" */ '@/components/AccessUnauthorized.vue'),
  },  
  { 
      path: "*", 
      component: () => import(/* webpackChunkName: "about" */ '@/components/PageNotFound.vue'), 
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(route => route.meta.requiresBasicAuth)) {
      if (store.state.user != null) {
        if(to.name == 'View-Seafarer' && to.query['mode'] != 'view'){
            next({ path: '/unauthorized' });
        }else{
            next();
        }
      } else {
        next({ path: '/login' });
      }
    }else if (to.matched.some(route => route.meta.requiresAuth)) {
        if (store.state.user != null) {
            if(store.state.user.role == 'Admin' || store.state.user.role == 'Operator'){
                next();
              }else{
                next({ path: '/unauthorized' });
            }
        } else {
          next({ path: '/login' });
        }
    }else if (to.matched.some(route => route.meta.requiresAdminAuth)) {
        if (store.state.user != null) {
          if(store.state.user.role == 'Admin'){
            next();
          }else{
            next({ path: '/unauthorized' });
          }
        } else {
          next({ path: '/login' });
        }
      }
    next();
  });

export default router
